import React from "react";
import PropTypes from "prop-types";
import { Flex } from "@sainsburys-tech/fable";
import Circle from "../../assets/images/Circle.svg";
import CircleRed from "../../assets/images/CircleRed.svg";

function AlertActiveIndicator(props) {
  const hoverColor = props.isHovered ? '#f06c00' : '#404040';
  
  if (props.alert.lastEventDeactivated === null) {
    return (
      <Flex alignItems="center" gap="sm">
        <div>
          <img src={CircleRed} alt="CircleRed" height={20} width={20} />
        </div>
        <div className="cb-c-alert-active-indicator__active-status-message">
          <div className="cb-c-alert-active-indicator__active-status-message__active" style={{ color: hoverColor, transition: 'color 0.2s ease' }}>
            Active now
          </div>
        </div>
      </Flex>
    );
  }
  return (
    <Flex alignItems="center" gap="sm">
      <div>
        <img src={Circle} alt="Circle" height={20} width={20} />
      </div>
      <div className="cb-c-alert-active-indicator__active-status-message">
        <div style={{ color: hoverColor, transition: 'color 0.2s ease' }}>Inactive</div>
      </div>
    </Flex>
  );
}
AlertActiveIndicator.propTypes = {
  alert: PropTypes.object,
  isHovered: PropTypes.bool
};

export default AlertActiveIndicator;
